// extracted by mini-css-extract-plugin
export default {"wrapper":"Dialog_wrapper__7J+Wl","header":"Dialog_header__AzT6x","row":"Dialog_row__k7ExN","footer":"Dialog_footer__v6dO5","modal":"Dialog_modal__2oW6K"};